module.exports = __webpack_public_path__ + "static/005_body-landscape-4c20f2508d2a24ab9d63069108eef2e1.mp4";